import { useFeatureFlag } from '@fs/zion-flags'
import { useMemo } from 'react'
import { useDynamicLinkContext } from '../DynamicLinksProvider'

/**
 * Extracts legal footer items from the dynamic navigation response keyed by id.
 * Returns null when the flag is off or navigation data is unavailable.
 */

function mapLegalItems(legalArray) {
  if (!Array.isArray(legalArray) || legalArray.length === 0) return null

  const validLegalItems = legalArray.filter(Boolean)
  if (validLegalItems.length === 0) return null

  return validLegalItems.reduce((acc, item) => {
    if (item?.id) {
      acc[item.id] = item
    }
    return acc
  }, {})
}

export default function useDynamicLegalFooter() {
  const { isOn } = useFeatureFlag('home_footer_dynamicLegalFooter')
  const { navigation, isLoading } = useDynamicLinkContext()
  const legalFooter = navigation?.legalFooter

  const isEnabled = Boolean(isOn && !isLoading && legalFooter?.length)

  const legalItems = useMemo(() => {
    if (!isEnabled) return null
    return mapLegalItems(legalFooter)
  }, [isEnabled, legalFooter])

  return { isEnabled, legalItems }
}
